<template>
  <div class="widget-heading pb-0 d-block">
    <div class="row">

      <div class="col-md-12 col-lg-10">
        <h4 class="d-inline-block h4" style="line-height: 1.4">
          Faktury KSEF:
        </h4>
      </div>

      <!-- Duży ekran -->
      <div class="col-md-12 btn-group d-none d-md-flex">
        <Link :href="route('kadry.faktury')" class="btn btn-outline-primary"
              :class="{ 'btn-primary': isRouteActive('kadry.faktury') }">Faktury otrzymane
        </Link>
        <Link :href="route('kadry.faktury_out')" class="btn btn-outline-primary"
              :class="{ 'btn-primary': isRouteActive('kadry.faktury_out') }">Faktury wystawione
        </Link> 
		<Link :href="route('kadry.opisy_faktur')" class="btn btn-outline-primary"
              :class="{ 'btn-primary': isRouteActive('kadry.opisy_faktur') }">Opisy faktur
        </Link>
      </div>

      <!-- Mały ekran -->
      <div class="col-12 d-md-none">
        <div class="dropdown">
          <button
              class="btn btn-outline-primary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
              type="button" @click="toggleDropdown">
            {{ activeLabel }}
            <i class="bi bi-list ms-2"></i>
          </button>
          <div class="dropdown-menu w-100" :class="{ show: isDropdownOpen }">
            <Link :href="route('kadry.faktury')" class="dropdown-item"
                  :class="{ 'active': isRouteActive('kadry.faktury') }">Faktury otrzymane
            </Link>
            <Link :href="route('kadry.faktury_out')" class="dropdown-item"
                  :class="{ 'active': isRouteActive('kadry.faktury_out') }">Faktury wystawione
            </Link>
            <Link :href="route('kadry.opisy_faktur')" class="dropdown-item"
                  :class="{ 'active': isRouteActive('kadry.opisy_faktur') }">Opisy faktur
            </Link>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {ref, computed} from "vue";
import route from "../../../../../vendor/tightenco/ziggy/src/js/index.js";

export default {
  setup() {
    const isDropdownOpen = ref(false);
    const toggleDropdown = () => {
      isDropdownOpen.value = !isDropdownOpen.value;
    };

    const isRouteActive = (routeName) => {
      return route().current(routeName);
    };

    // mapowanie trasa -> etykieta
    const labels = {
      "kadry.faktury": "Faktury otrzymane",
      "kadry.faktury_out": "Faktury wystawione",
      "kadry.opisy_faktur": "Opisy faktur",
    };

    const activeLabel = computed(() => {
      const current = route().current();
      return labels[current] || "Menu";
    });

    return {
      route,
      isRouteActive,
      isDropdownOpen,
      toggleDropdown,
      activeLabel,
    };
  },
};
</script>
